import React from 'react';
import KeyValueList from '@components/v2/KeyValueList';
import ExternalEntitySelector from '@components/v2/ExternalEntitySelector';
import Label from '@components/Label';
import { translate } from '@utils/i18n';
import getGeneralInfo from '../utils/getGeneralInfo';
import { namespace } from '../constants';
export default function FeeInformation({ proposal, handlePriceListUpdate, handleTaxRateUpdate, handleShowProfitMarginUpdate, handleFieldUpdate }) {
    var _a, _b, _c, _d;
    const detailInfo = getGeneralInfo(proposal);
    const priceListUrl = `/api/internal/proposals/${proposal.id}/available_price_lists`;
    const taxRateUrl = `/api/internal/proposals/${proposal.id}/available_tax_rates`;
    return (React.createElement("div", { className: "span6", style: { paddingLeft: '18px', border: '1px solid #ccc' } },
        React.createElement("div", { className: "keyValueListContainer" },
            proposal.enablePriceList && (React.createElement("div", { className: "info-row" },
                React.createElement(Label, { htmlFor: "priceList", className: "info-key" },
                    translate('price_list', { namespace: `${namespace}.fields` }),
                    ":"),
                React.createElement(ExternalEntitySelector, { className: "info-value", showSearch: true, maxHeight: 280, allowClear: false, url: priceListUrl, value: ((_b = (_a = proposal.priceList) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()) || null, onChange: (priceList) => {
                        if (priceList) {
                            handlePriceListUpdate({
                                id: priceList.id,
                                name: priceList.name
                            });
                        }
                    } }))),
            proposal.enableTaxGroups && (React.createElement("div", { className: "info-row" },
                React.createElement(Label, { htmlFor: translate('tax_rate', { namespace: `${namespace}.fields` }), className: "info-key" },
                    translate('tax_rate', { namespace: `${namespace}.fields` }),
                    ":"),
                React.createElement(ExternalEntitySelector, { className: "info-value", maxHeight: 280, allowClear: false, showSearch: true, url: taxRateUrl, value: ((_d = (_c = proposal.tax) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.toString()) || null, onChange: (taxRate) => {
                        if (taxRate) {
                            handleTaxRateUpdate({
                                id: taxRate.id,
                                name: taxRate.name,
                                rate: taxRate.rate.toString()
                            });
                        }
                    } })))),
        React.createElement(KeyValueList, { items: detailInfo.group2, onEdit: handleFieldUpdate }),
        React.createElement("div", { className: "checkboxListContainer" },
            React.createElement("label", { className: "qmb-checkbox" },
                React.createElement("input", { type: "checkbox", checked: proposal.showProfitMargin, onChange: () => handleShowProfitMarginUpdate(!proposal.showProfitMargin) }),
                React.createElement("p", { className: "qmb-checkbox-label", style: { padding: 0 }, onClick: (e) => {
                        e.preventDefault();
                        handleShowProfitMarginUpdate(!proposal.showProfitMargin);
                    } },
                    React.createElement("span", { className: "qmb-checkbox-title" }, "Show Profit Margin"))))));
}
